// pages/LandingPage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  FaTruck, 
  FaMapMarkerAlt, 
  FaUserShield, 
  FaHeartbeat, 
  FaBell, 
  FaUsers,
  FaShieldAlt,
  FaSignInAlt
} from 'react-icons/fa';

const LandingPage = () => {
  const colors = {
    primary: '#e28743', // primary
    secondary: '#304a3f', // secondary
    dark: '#1a1a1a',
    light: '#f5f5f5',
    accent: '#d9b18c'
  };

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-br from-[#304a3f] to-[#1a1a1a]">
      
      {/* Header */}
      <header className="bg-white/10 backdrop-blur-md border-b border-white/20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-center py-4">
            <div className="flex items-center">
              <div className="w-10 h-10 rounded-full mr-3 flex items-center justify-center" style={{ backgroundColor: colors.primary }}>
                <FaTruck className="text-white" />
              </div>
              <h1 className="text-2xl sm:text-3xl font-bold text-white">FleetsCounty</h1>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="text-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 md:py-32">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Intelligent Fleet Management
        </h1>
        <p className="text-lg sm:text-xl md:text-2xl mb-12 max-w-3xl mx-auto text-gray-200">
          Safety, Efficiency, and Real-Time Monitoring for Your Fleet Operations
        </p>
        <Link 
          to="/login"
          className="inline-flex items-center px-8 sm:px-10 py-3 sm:py-4 rounded-xl text-lg sm:text-xl font-bold transition-transform transform hover:scale-105 hover:shadow-xl"
          style={{ backgroundColor: colors.primary, color: 'white' }}
        >
          <FaSignInAlt className="mr-2 sm:mr-3" />
          Get Started
        </Link>
      </section>

      {/* Features Grid */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {[
            { icon: FaTruck, title: 'Real-time GPS Tracking', desc: 'Advanced geofencing and live vehicle tracking', bg: 'rgba(226,135,67,0.1)', border: colors.primary },
            { icon: FaUserShield, title: 'AI Fatigue Detection', desc: 'Driver wellness monitoring and alerts', bg: 'rgba(48,74,63,0.1)', border: colors.secondary },
            { icon: FaHeartbeat, title: 'Healthcare Booking', desc: 'Driver health and safety management', bg: 'rgba(226,135,67,0.1)', border: colors.primary }
          ].map((feature, idx) => (
            <div 
              key={idx} 
              className="p-6 sm:p-8 rounded-xl border backdrop-blur-md transition-transform transform hover:scale-105 hover:shadow-lg"
              style={{ backgroundColor: feature.bg, borderColor: feature.border }}
            >
              <feature.icon size={40} className="mx-auto mb-4" style={{ color: feature.border }} />
              <h3 className="text-white font-semibold text-lg sm:text-xl mb-2">{feature.title}</h3>
              <p className="text-sm sm:text-base text-gray-200">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Additional Features */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
        <h2 className="text-3xl sm:text-4xl font-bold text-white text-center mb-12">Complete Fleet Management Solution</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[
            { icon: FaMapMarkerAlt, title: 'Geofencing', desc: 'Define and monitor geographic zones', color: colors.primary },
            { icon: FaBell, title: 'Smart Alerts', desc: 'Real-time notifications for fleet safety', color: colors.primary },
            { icon: FaUsers, title: 'Driver Management', desc: 'Complete driver profiles & tracking', color: colors.secondary },
            { icon: FaShieldAlt, title: 'Safety Compliance', desc: 'Meet all regulatory requirements', color: colors.secondary }
          ].map((feature, idx) => (
            <div key={idx} className="text-center p-6 sm:p-8 rounded-xl" style={{ backgroundColor: 'rgba(48, 74, 63, 0.3)' }}>
              <feature.icon size={36} className="mx-auto mb-4" style={{ color: feature.color }} />
              <h3 className="text-white font-semibold mb-2">{feature.title}</h3>
              <p className="text-sm sm:text-base text-gray-200">{feature.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Footer */}
      <footer className="border-t border-white/20 py-8 mt-auto">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-gray-300 text-sm sm:text-base">
            © 2024 FleetsCounty. Intelligent Fleet Management System.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
